import type { LocateInjectionCsvParseResult } from '../parseLocateInjectionCsv';

export type LocatesInjectionMode = 'single' | 'csv';
export type LocatesInjectionStatus = 'idle' | 'parsing' | 'submitting';

export interface SingleLocateInjectionDraft {
    accountId: string;
    providerId: string;
    symbol: string;
    quantity: string;
    pricePerShare: string;
}

export interface CsvLocateInjectionDraft {
    accountId: string;
    providerId: string;
    file: { name: string; size: number } | null;
    parseResult: LocateInjectionCsvParseResult | null;
}

export interface LocatesInjectionState {
    mode: LocatesInjectionMode | null;
    status: LocatesInjectionStatus;
    single: SingleLocateInjectionDraft;
    csv: CsvLocateInjectionDraft;
    submissionError: string | null;
}

export const EMPTY_SINGLE_LOCATE_INJECTION_DRAFT: SingleLocateInjectionDraft = {
    accountId: '',
    providerId: '',
    symbol: '',
    quantity: '100',
    pricePerShare: '0',
};

export const EMPTY_CSV_LOCATE_INJECTION_DRAFT: CsvLocateInjectionDraft = {
    accountId: '',
    providerId: '',
    file: null,
    parseResult: null,
};

export function createInitialLocatesInjectionState(): LocatesInjectionState {
    return {
        mode: null,
        status: 'idle',
        single: { ...EMPTY_SINGLE_LOCATE_INJECTION_DRAFT },
        csv: { ...EMPTY_CSV_LOCATE_INJECTION_DRAFT },
        submissionError: null,
    };
}
